import { useClerk } from '@clerk/react-router';
import { useLingui } from '@lingui/react/macro';
import { Dropdown } from 'app-ui/components';
import { IconShield } from 'app-ui/icon';

// Clerk's account dialog: email addresses, password, connected accounts and
// two-step verification.
export const ClerkManageAccountItem = () => {
  const { t } = useLingui();
  const { openUserProfile } = useClerk();

  const handleManageAccountClick = () => {
    openUserProfile();
  };

  return (
    <Dropdown.ActionItem
      startIcon={<IconShield />}
      onClick={handleManageAccountClick}
    >
      {t`Manage account`}
    </Dropdown.ActionItem>
  );
};
